import { atom } from "jotai";

export const skuListAtom = atom([]);
export const skuDetailAtom = atom(null);
